import React, { createContext, useEffect, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [profilePic, setLoggedInProfilePic] = useState(
    sessionStorage.getItem("profilepic")
  );

  const setProfilePic = (val) => {
    sessionStorage.setItem("profilepic", val);
    setLoggedInProfilePic(val);
  };

  useEffect(() => {
    const storedPic = sessionStorage.getItem("profilepic");
    if (storedPic) {
      setLoggedInProfilePic(storedPic);
    }
  }, []);

  return (
    <AppContext.Provider value={{ theme, setTheme }}>
      {children}
    </AppContext.Provider>
  );
};
